import { render, staticRenderFns } from "./allgroup.vue?vue&type=template&id=518ababd&scoped=true&"
import script from "./allgroup.vue?vue&type=script&lang=js&"
export * from "./allgroup.vue?vue&type=script&lang=js&"
import style0 from "./allgroup.vue?vue&type=style&index=0&id=518ababd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518ababd",
  null
  
)

export default component.exports